var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "pull-up",
      attrs: { tile: "", loading: _vm.isLoading },
      on: {
        click: function() {
          return _vm.openFile()
        }
      }
    },
    [
      _c(
        "v-list-item",
        { staticClass: "py-4 px-8" },
        [
          _c(
            "v-list-item-avatar",
            [
              _c("v-icon", { attrs: { large: "", color: "red" } }, [
                _vm._v(" mdi-adobe-acrobat ")
              ])
            ],
            1
          ),
          _c("v-list-item-title", { staticClass: "overline" }, [
            _vm._v(_vm._s(_vm.file.name))
          ]),
          _vm.$can("delete", "INFODAYCO")
            ? _c(
                "v-list-item-action",
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      attrs: { icon: "" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return (function() {
                                            return _vm.deleteFile()
                                          })($event)
                                        }
                                      }
                                    },
                                    on
                                  ),
                                  [_c("v-icon", [_vm._v("mdi-delete")])],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3094627210
                      )
                    },
                    [_c("span", [_vm._v("Eliminar")])]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }